import { Label } from '@/components/ui/label';

interface CheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  label: string;
  value?: string;
}

export const Checkbox = ({ checked, onCheckedChange, label, value }: CheckboxProps) => (
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  <div className="boder-gray-300 mb-2 mr-4 flex cursor-pointer items-center rounded-lg border-2 px-2 py-1">
    <Label className="flex items-center justify-center">
      <input
        type="checkbox"
        value={value}
        checked={checked}
        onChange={(e) => {
          onCheckedChange(e.target.checked);
        }}
        className="h-4 w-4  cursor-pointer rounded border-gray-300 text-blue-600 focus:ring-blue-500"
      />
      <span className="ml-2 cursor-pointer font-cadiz text-sm text-gray-700">{label}</span>
    </Label>
  </div>
);
